import React from "react";
import styled from "styled-components";

export default styled.span`
    background: #D8EAF8;
    display: inline-block;
    float: left;
    border-radius: 12.5px;
    font-size: 12px;
    padding: 5px 15px;
    font-weight: 700;
    color: #007FA4;
    line-height: 15px;
    margin-right: 10px;
    height: 25px;
    text-align: center;
    display: ${(props) => (props.hidden ? "none" : "block")};
    
    &:hover {
        // background: #007FA4;
        // color: white;
        // &:after {
        //     content: 'x';
        //     margin-left: 5px;
        //     right: -5px;
        //     position: relative;
        // }
    }
`;